var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 426,
    height: 171,
    viewBox: "0 0 426 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.4328 46.8828C82.9427 47.2998 82.8834 48.0352 83.3003 48.5254L87.7505 53.7564C88.1674 54.2466 88.9028 54.3059 89.393 53.8889L94.1638 49.8304L97.8319 54.1422L107.533 45.8897L103.864 41.5778L108.906 37.2892C109.396 36.8722 109.455 36.1368 109.038 35.6467L104.588 30.4156C104.171 29.9255 103.436 29.8661 102.946 30.2831L83.4328 46.8828Z",
    fill: "url(#paint0_linear_1_11)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.641 29.0709C186.154 28.65 185.418 28.7034 184.997 29.1902L180.505 34.3855C180.084 34.8723 180.138 35.6081 180.625 36.029L185.363 40.1259L181.66 44.4085L191.295 52.7384L194.997 48.4558L200.004 52.7844C200.491 53.2053 201.226 53.1518 201.647 52.665L206.139 47.4698C206.56 46.983 206.507 46.2471 206.02 45.8262L186.641 29.0709Z",
    fill: "url(#paint1_linear_1_11)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.025 16.491C127.381 16.4843 126.854 17.0005 126.847 17.644L126.75 26.8548C126.744 27.4983 127.26 28.0255 127.903 28.0323L136.059 28.1181L135.984 35.2208L151.965 35.3889L152.039 28.2863L160.64 28.3768C161.284 28.3836 161.811 27.8674 161.818 27.2239L161.915 18.013C161.922 17.3695 161.405 16.8423 160.762 16.8356L128.025 16.491Z",
    fill: "url(#paint2_linear_1_11)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.86532 163.563C7.86532 167.666 11.1911 170.992 15.2937 170.992H34.2287C38.3312 170.992 41.657 167.666 41.657 163.563C41.657 159.461 38.3312 156.135 34.2287 156.135H15.2937C11.1911 156.135 7.86532 159.461 7.86532 163.563ZM139.217 30.2292C177.756 27.1207 211.518 55.8429 214.627 94.3822C217.735 132.922 189.013 166.684 150.474 169.792C146.362 170.124 142.304 170.093 138.332 169.727H54.2465C50.16 169.727 46.8473 166.414 46.8473 162.328C46.8473 159.528 48.4027 157.091 50.6967 155.834H81.8138C85.9003 155.834 89.2131 152.521 89.2131 148.435C89.2131 144.348 85.9003 141.036 81.8138 141.036H75.3935V141.034H7.39924C3.31275 141.034 0 137.721 0 133.635C0 130.228 2.30191 127.359 5.43506 126.499H72.0065C72.6866 126.499 73.3452 126.407 73.9707 126.235H79.9141L79.9139 126.235H73.9723C77.1046 125.374 79.4057 122.505 79.4057 119.1C79.4057 115.013 76.093 111.7 72.0065 111.7H51.986C49.0051 110.745 46.8473 107.951 46.8473 104.653C46.8473 101.692 48.5861 99.1377 51.0982 97.9549H82.7771C86.8636 97.9549 90.1763 94.6421 90.1763 90.5556C90.1763 86.4691 86.8636 83.1564 82.7771 83.1564H58.0556V83.0669C53.9892 83.0435 50.7 79.7398 50.7 75.6678C50.7 71.5814 54.0128 68.2686 58.0993 68.2686H82.4355C93.1091 47.3321 114.074 32.2573 139.217 30.2292ZM29.1308 105.157C29.1308 108.36 31.378 111.038 34.3817 111.7H37.28C40.2837 111.038 42.5309 108.36 42.5309 105.157C42.5309 101.457 39.5312 98.4574 35.8308 98.4574C32.1305 98.4574 29.1308 101.457 29.1308 105.157ZM134.481 54.0111C111.916 59.0651 95.9384 80.0908 97.8509 103.801C99.9444 129.755 122.681 149.098 148.636 147.005C174.59 144.911 193.933 122.174 191.839 96.2202C190.143 75.1938 174.898 58.5064 155.371 54.0409L150.088 62.9756L161.967 111.474L144.78 127.893L127.593 111.474L138.967 62.9756L134.481 54.0111Z",
    fill: "url(#paint3_linear_1_11)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.601 63.5586L124.223 61.4679L128.107 68.1962C128.685 69.1962 128.342 70.4748 127.342 71.0521C126.342 71.6295 125.063 71.2869 124.486 70.2869L120.601 63.5586Z",
    fill: "url(#paint4_linear_1_11)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.745 80.5365L107.823 76.908L113.399 80.1017C114.401 80.6755 114.748 81.953 114.174 82.9549C113.6 83.9569 112.323 84.3039 111.321 83.7301L105.745 80.5365Z",
    fill: "url(#paint5_linear_1_11)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.792 102.644L100.792 98.4627L107.219 98.4627C108.373 98.4627 109.309 99.3987 109.309 100.553C109.309 101.708 108.373 102.644 107.219 102.644L100.792 102.644Z",
    fill: "url(#paint6_linear_1_11)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M107.835 123.532L105.745 119.911L111.31 116.698C112.31 116.121 113.588 116.464 114.166 117.463C114.743 118.463 114.4 119.742 113.4 120.319L107.835 123.532Z",
    fill: "url(#paint7_linear_1_11)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M124.223 138.808L120.601 136.717L123.814 131.152C124.392 130.152 125.67 129.81 126.67 130.387C127.67 130.964 128.013 132.243 127.436 133.243L124.223 138.808Z",
    fill: "url(#paint8_linear_1_11)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M146.048 143.685L141.867 143.685L141.867 137.259C141.867 136.104 142.803 135.168 143.958 135.168C145.112 135.168 146.048 136.104 146.048 137.259L146.048 143.685Z",
    fill: "url(#paint9_linear_1_11)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M167.807 136.72L164.186 138.811L160.973 133.245C160.396 132.245 160.738 130.967 161.738 130.389C162.738 129.812 164.017 130.155 164.594 131.155L167.807 136.72Z",
    fill: "url(#paint10_linear_1_11)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M182.794 120.199L180.704 123.82L175.139 120.607C174.139 120.03 173.796 118.751 174.373 117.751C174.951 116.751 176.229 116.409 177.229 116.986L182.794 120.199Z",
    fill: "url(#paint11_linear_1_11)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M187.671 98.4644L187.692 102.646L181.266 102.679C180.112 102.685 179.171 101.753 179.165 100.599C179.159 99.4441 180.09 98.5033 181.245 98.4974L187.671 98.4644Z",
    fill: "url(#paint12_linear_1_11)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M180.715 76.9081L182.796 80.5349L177.222 83.7329C176.221 84.3075 174.943 83.9614 174.369 82.9599C173.794 81.9584 174.14 80.6807 175.142 80.1061L180.715 76.9081Z",
    fill: "url(#paint13_linear_1_11)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M164.666 61.4671L168.04 63.9362L164.246 69.1223C163.564 70.0542 162.256 70.2569 161.324 69.5751C160.392 68.8933 160.189 67.5851 160.871 66.6533L164.666 61.4671Z",
    fill: "url(#paint14_linear_1_11)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M260.421 40.1598L255.5 68.1821C254.66 72.9425 252.72 76.5828 249.68 79.103C246.68 81.6232 242.919 82.8833 238.399 82.8833C234.239 82.8833 230.959 81.8632 228.558 79.823C226.158 77.7829 224.958 74.8226 224.958 70.9423C224.958 69.8222 225.078 68.6021 225.318 67.282H237.019C236.899 67.9221 236.839 68.5221 236.839 69.0822C236.839 71.2023 237.819 72.2624 239.779 72.2624C241.859 72.2624 243.179 70.9023 243.74 68.1821L248.66 40.1598H260.421ZM275.601 82.8833C272.681 82.8833 270.081 82.3032 267.801 81.1431C265.56 79.9831 263.82 78.3429 262.58 76.2228C261.34 74.1026 260.72 71.6224 260.72 68.7821C260.72 64.9418 261.62 61.4616 263.42 58.3413C265.26 55.221 267.781 52.7809 270.981 51.0207C274.181 49.2606 277.761 48.3805 281.722 48.3805C284.642 48.3805 287.222 48.9605 289.462 50.1206C291.742 51.2807 293.503 52.9409 294.743 55.101C296.023 57.2212 296.663 59.7014 296.663 62.5416C296.663 66.422 295.743 69.9222 293.903 73.0425C292.063 76.1227 289.542 78.5429 286.342 80.3031C283.142 82.0232 279.562 82.8833 275.601 82.8833ZM277.401 72.7425C278.801 72.7425 280.042 72.3024 281.122 71.4224C282.242 70.5423 283.082 69.4022 283.642 68.0021C284.242 66.602 284.542 65.1619 284.542 63.6817C284.542 62.0016 284.102 60.7215 283.222 59.8414C282.382 58.9614 281.282 58.5213 279.922 58.5213C278.481 58.5213 277.221 58.9614 276.141 59.8414C275.101 60.7215 274.281 61.8616 273.681 63.2617C273.121 64.6618 272.841 66.1219 272.841 67.6421C272.841 69.3222 273.261 70.6023 274.101 71.4824C274.941 72.3224 276.041 72.7425 277.401 72.7425ZM315.009 53.4809C316.169 51.9208 317.669 50.6807 319.509 49.7606C321.389 48.8405 323.47 48.3805 325.75 48.3805C329.27 48.3805 332.09 49.5406 334.21 51.8608C336.371 54.181 337.451 57.3612 337.451 61.4016C337.451 62.6817 337.331 64.0818 337.091 65.6019C336.451 69.0822 335.271 72.1424 333.55 74.7826C331.83 77.3828 329.75 79.383 327.31 80.7831C324.91 82.1832 322.37 82.8833 319.689 82.8833C317.369 82.8833 315.449 82.4433 313.929 81.5632C312.449 80.6431 311.389 79.383 310.749 77.7829L309.908 82.4633H298.088L305.948 38.0597H317.769L315.009 53.4809ZM325.09 65.6019C325.21 65.0018 325.27 64.4218 325.27 63.8618C325.27 62.2216 324.79 60.9415 323.83 60.0214C322.91 59.1014 321.709 58.6413 320.229 58.6413C318.509 58.6413 316.929 59.2614 315.489 60.5015C314.089 61.7416 313.209 63.4417 312.849 65.6019C312.729 66.2019 312.669 66.762 312.669 67.282C312.669 68.9622 313.129 70.2823 314.049 71.2423C315.009 72.1624 316.229 72.6225 317.709 72.6225C319.469 72.6225 321.049 72.0024 322.45 70.7623C323.85 69.4822 324.73 67.7621 325.09 65.6019ZM225.978 126.602C226.618 123.122 227.798 120.081 229.518 117.481C231.239 114.881 233.299 112.881 235.699 111.481C238.139 110.081 240.699 109.38 243.38 109.38C245.7 109.38 247.62 109.841 249.14 110.761C250.66 111.681 251.72 112.921 252.32 114.481L253.16 109.801H264.921L258.981 143.463H247.22L248.06 138.783C246.9 140.343 245.38 141.583 243.5 142.503C241.619 143.423 239.539 143.883 237.259 143.883C233.739 143.883 230.919 142.723 228.798 140.403C226.678 138.043 225.618 134.843 225.618 130.802C225.618 129.482 225.738 128.082 225.978 126.602ZM250.22 126.602C250.34 126.002 250.4 125.442 250.4 124.922C250.4 123.242 249.92 121.942 248.96 121.021C248.04 120.101 246.84 119.641 245.36 119.641C243.6 119.641 242.019 120.261 240.619 121.501C239.219 122.702 238.339 124.402 237.979 126.602C237.859 127.202 237.799 127.782 237.799 128.342C237.799 130.022 238.259 131.322 239.179 132.242C240.139 133.162 241.359 133.622 242.839 133.622C244.6 133.622 246.18 133.002 247.58 131.762C248.98 130.522 249.86 128.802 250.22 126.602ZM282.604 114.481C283.804 112.921 285.324 111.681 287.164 110.761C289.004 109.841 291.065 109.38 293.345 109.38C296.865 109.38 299.685 110.541 301.805 112.861C303.966 115.181 305.046 118.361 305.046 122.402C305.046 123.682 304.926 125.082 304.686 126.602C304.046 130.082 302.866 133.142 301.145 135.783C299.425 138.383 297.345 140.383 294.905 141.783C292.505 143.183 289.965 143.883 287.284 143.883C285.004 143.883 283.104 143.423 281.584 142.503C280.104 141.583 279.024 140.343 278.344 138.783L274.683 159.545H262.922L271.683 109.801H283.444L282.604 114.481ZM292.685 126.602C292.805 126.002 292.865 125.422 292.865 124.862C292.865 123.222 292.385 121.942 291.425 121.021C290.505 120.101 289.304 119.641 287.824 119.641C286.104 119.641 284.524 120.261 283.084 121.501C281.684 122.742 280.804 124.442 280.444 126.602C280.324 127.202 280.264 127.762 280.264 128.282C280.264 129.962 280.724 131.282 281.644 132.242C282.604 133.162 283.824 133.622 285.304 133.622C287.064 133.622 288.644 133.002 290.045 131.762C291.445 130.482 292.325 128.762 292.685 126.602ZM323.388 114.481C324.589 112.921 326.109 111.681 327.949 110.761C329.789 109.841 331.849 109.38 334.129 109.38C337.65 109.38 340.47 110.541 342.59 112.861C344.75 115.181 345.83 118.361 345.83 122.402C345.83 123.682 345.71 125.082 345.47 126.602C344.83 130.082 343.65 133.142 341.93 135.783C340.21 138.383 338.13 140.383 335.689 141.783C333.289 143.183 330.749 143.883 328.069 143.883C325.789 143.883 323.889 143.423 322.368 142.503C320.888 141.583 319.808 140.343 319.128 138.783L315.468 159.545H303.707L312.468 109.801H324.229L323.388 114.481ZM333.469 126.602C333.589 126.002 333.649 125.422 333.649 124.862C333.649 123.222 333.169 121.942 332.209 121.021C331.289 120.101 330.089 119.641 328.609 119.641C326.889 119.641 325.309 120.261 323.869 121.501C322.468 122.742 321.588 124.442 321.228 126.602C321.108 127.202 321.048 127.762 321.048 128.282C321.048 129.962 321.508 131.282 322.428 132.242C323.388 133.162 324.609 133.622 326.089 133.622C327.849 133.622 329.429 133.002 330.829 131.762C332.229 130.482 333.109 128.762 333.469 126.602ZM366.933 99.0597L359.073 143.463H347.252L355.112 99.0597H366.933ZM381.131 109.801L384.792 128.882L394.993 109.801H407.894L377.831 159.485H365.05L376.151 142.023L368.05 109.801H381.131Z",
    fill: "#142455"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M329.73 87.3971C335.407 83.4589 340.01 80.16 343.539 77.5004C347.12 74.7897 350.214 72.0278 352.822 69.2148C355.431 66.4018 356.939 63.7934 357.349 61.3895C357.451 60.5712 357.502 60.0086 357.502 59.7017C357.502 57.4002 356.351 56.2494 354.05 56.2494C352.567 56.2494 351.365 56.812 350.444 57.9372C349.523 59.0624 348.807 60.9548 348.296 63.6144H333.719C335.151 56.8631 338.041 51.8509 342.389 48.5775C346.736 45.2531 351.723 43.5908 357.349 43.5908C362.821 43.5908 366.836 44.7928 369.393 47.1966C371.951 49.6005 373.229 52.7459 373.229 56.633C373.229 57.8605 373.127 58.9857 372.923 60.0086C372.002 65.0209 369.393 69.7774 365.097 74.2782C360.852 78.7279 355.763 82.794 349.83 86.4765H369.01L366.862 98.6747H327.735L329.73 87.3971ZM374.252 90.2357L376.401 77.8073L405.861 44.2046H422.355L416.601 77.1935H422.508L420.207 90.2357H414.3L412.612 99.4419H397.498L399.109 90.2357H374.252ZM405.4 61.1594L391.974 77.1935H402.562L405.4 61.1594Z",
    fill: "#0094DA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_11",
    x1: 108.904,
    y1: 39.0088,
    x2: 82.0992,
    y2: 46.6982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#184BA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62863,
    stopColor: "#198AD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#188CD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_11",
    x1: 198.304,
    y1: 53.0445,
    x2: 186.62,
    y2: 27.7247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#184BA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62863,
    stopColor: "#198AD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#188CD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_11",
    x1: 159.036,
    y1: 30.0547,
    x2: 127.087,
    y2: 15.1604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#184BA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62863,
    stopColor: "#198AD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#188CD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_11",
    x1: 211.489,
    y1: 82.1772,
    x2: 7.76141,
    y2: 164.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#184BA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62863,
    stopColor: "#198AD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#188CD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_11",
    x1: 126.003,
    y1: 64.6826,
    x2: 122.312,
    y2: 67.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#184BA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62863,
    stopColor: "#198AD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#188CD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_11",
    x1: 110.544,
    y1: 78.5422,
    x2: 108.799,
    y2: 82.7715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#184BA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62863,
    stopColor: "#198AD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#188CD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_11",
    x1: 103.966,
    y1: 98.5282,
    x2: 104.553,
    y2: 103.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#184BA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62863,
    stopColor: "#198AD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#188CD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_11",
    x1: 108.526,
    y1: 118.381,
    x2: 111.303,
    y2: 122.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#184BA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62863,
    stopColor: "#198AD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#188CD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_11",
    x1: 122.245,
    y1: 134.002,
    x2: 126.468,
    y2: 135.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#184BA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62863,
    stopColor: "#198AD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#188CD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_11",
    x1: 141.932,
    y1: 140.511,
    x2: 146.47,
    y2: 139.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#184BA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62863,
    stopColor: "#198AD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#188CD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_11",
    x1: 162.656,
    y1: 136.029,
    x2: 166.292,
    y2: 133.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#184BA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62863,
    stopColor: "#198AD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#188CD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_11",
    x1: 177.988,
    y1: 122.177,
    x2: 179.748,
    y2: 117.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#184BA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62863,
    stopColor: "#198AD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#188CD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1_11",
    x1: 184.518,
    y1: 102.596,
    x2: 183.908,
    y2: 98.0621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#184BA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62863,
    stopColor: "#198AD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#188CD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_11",
    x1: 180.011,
    y1: 82.0575,
    x2: 177.243,
    y2: 78.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#184BA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62863,
    stopColor: "#198AD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#188CD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1_11",
    x1: 166.113,
    y1: 66.4588,
    x2: 162.105,
    y2: 64.2534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#184BA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62863,
    stopColor: "#198AD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#188CD6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.57cdc39fa34502455017163a0e352110.svg";
export { ForwardRef as ReactComponent };